/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { action, observable } from 'mobx';
import { LabelType } from 'src/customText/core/stores/CustomTextEntityLabelStore';
import { CustomTextEntityStore } from 'src/customText/core/stores/CustomTextEntityStore';
import { ExtractionEntityDropdownData } from 'src/customText/verticals/extractionLabeler/ExtractionEntityDropdown';
import { Label } from 'src/modules/labeling/types/Label';
import { BaseTokenStore } from 'src/packages/react-text-annotator/lib/esm';

export type EntityLabel = {
    endCharIndex: number;
    startCharIndex: number;
    labelType?: LabelType;
    entity: CustomTextEntityStore;
};

export type PartialEntityLabel = Omit<EntityLabel, 'entity'> & { entityId: string };

export class ExtractionLabelerUIStore {
    @observable public dropdownData: ExtractionEntityDropdownData;

    /**
     * Sets dropdown data.
     */
    @action
    public setDropdownData(data: ExtractionEntityDropdownData) {
        this.dropdownData = data;
    }
}

export class ExtractionLabelerTokenStore extends BaseTokenStore {
    public readonly label: Label;

    constructor(index: number, text: string, label: Label) {
        super(index, text);
        this.label = label;
    }
}
